var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    // Styles for the line
    'absolute',
    'z-drop-indicator',
    {
      'inset-y-0': _setup.isVertical,
      'inset-x-0': !_setup.isVertical,
    },
    {
      'w-0.5': _setup.isVertical,
      'h-0.5': !_setup.isVertical,
    },
    'opacity-100',
    'pointer-events-none',
    {
      'bg-grape-500': _vm.darkMode === false,
      'bg-canary-500': _vm.darkMode === true,
      'bg-grape-500 dark:bg-canary-500': _vm.darkMode === 'auto',
    },

    // Styles for the starting dot
    `before:content-['']`,
    'before:absolute',
    {
      'before:-top-0.75': _setup.isVertical,
      'before:-start-0.5': _setup.isVertical,
      'before:-top-0.5': !_setup.isVertical,
      'before:-start-0.75': !_setup.isVertical,
    },
    'before:rounded-full',
    'before:w-1.5',
    'before:h-1.5',
    {
      'before:bg-grape-500': _vm.darkMode === false,
      'before:bg-canary-500': _vm.darkMode === true,
      'before:bg-grape-500 dark:before:bg-canary-500': _vm.darkMode === 'auto',
    },

    // Styles for the ending dot
    `after:content-['']`,
    'after:absolute',
    {
      'after:-bottom-0.75': _setup.isVertical,
      'after:-start-0.5': _setup.isVertical,
      'after:-bottom-0.5': !_setup.isVertical,
      'after:-end-0.75': !_setup.isVertical,
    },
    'after:rounded-full',
    'after:w-1.5',
    'after:h-1.5',
    {
      'after:bg-grape-500': _vm.darkMode === false,
      'after:bg-canary-500': _vm.darkMode === true,
      'after:bg-grape-500 dark:after:bg-canary-500': _vm.darkMode === 'auto',
    },
  ],style:(_setup.styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }